import React from "react";
import Page from "../components/Page";
import {
  Accordion,
  AccordionSummary,
  Card,
  Container,
  Grid,
  Stack,
  Typography,
} from "@mui/material";
import { Link } from "react-router-dom";
const Reportes2 = () => {
  return (
    <>
      <Page title="Reportes">
        <Container maxWidth="xl">
          <Stack
            direction="row"
            alignItems="center"
            justifyContent="space-between"
            mb={5}
          >
            <Typography variant="h4" gutterBottom>
              Catálogo de Reportes
            </Typography>
          </Stack>
          <Grid item xs={12} md={12} lg={12}>
            <Link to="/dashboard/reportegeneral">
              <Accordion>
                <AccordionSummary
                  aria-controls="panel1a-content"
                  id="panel1a-header"
                >
                  <Typography>Reporte General</Typography>
                </AccordionSummary>
              </Accordion>
            </Link>
            <Link to="/dashboard/reporteegresos">
            <Accordion>
              <AccordionSummary
                aria-controls="panel1a-content"
                id="panel1a-header"
              >
                <Typography>Reporte de Egresos</Typography>
              </AccordionSummary>
            </Accordion>
            </Link>
            <Link to="/dashboard/balance-general">
            <Accordion>
              <AccordionSummary
                aria-controls="panel1a-content"
                id="panel1a-header"
              >
                <Typography>Balance General</Typography>
              </AccordionSummary>
            </Accordion>
            </Link>
          </Grid>
        </Container>
      </Page>
    </>
  );
};

export default Reportes2;
